import { invokeApi } from "../../utils/invokeApi/invokeApi";

export const get_jobs_list = async (page, limit, search, slug) => {
  const requestObj = {
    path: `api/jobs/list?page=${page}&limit=${limit}&search=${search}${
      slug ? `&source_slug=${slug}` : ""
    }`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};

export const _get_job_feed_list_blog_api_without_filters = async (
  catid,
  search,
  path
) => {
  const requestObj = {
    path: `${path}&search=${search}&source_slug=${catid}`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};
export const upload_image_documents_on_s3 = async (data) => {
  const requestObj = {
    path: `api/app_api/upload_image_s3`,
    method: "POST",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    postData: data,
  };
  return invokeApi(requestObj);
};
export const upload_file_on_s3 = async (data) => {
  const requestObj = {
    path: `api/app_api/upload_file_s3`,
    method: "POST",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    postData: data,
  };
  return invokeApi(requestObj);
};

export const get_job_list_with_path = async (
  catid,
  search,
  path,
  filters = {},
  alert = "false"
) => {
  let dateQuery = "";
  if (filters.last24Hours) {
    dateQuery = "&last24Hours=true";
  } else if (filters.startDate && filters.endDate) {
    dateQuery = `&startDate=${encodeURIComponent(
      filters.startDate
    )}&endDate=${encodeURIComponent(filters.endDate)}`;
  }

  const filterQuery = `&location=${encodeURIComponent(
    filters.location || ""
  )}&education=${encodeURIComponent(
    filters.education || ""
  )}&jobType=${encodeURIComponent(
    filters.jobType || ""
  )}&experience=${encodeURIComponent(
    filters.experience || ""
  )}&minSalary=${encodeURIComponent(
    filters.minSalary || ""
  )}&maxSalary=${encodeURIComponent(
    filters.maxSalary || ""
  )}&frequencySalary=${encodeURIComponent(
    filters.frequencySalary || ""
  )}&clientName=${encodeURIComponent(filters.clientName || "")}${dateQuery}`;

  const requestObj = {
    path: `${path}&search=${search}${filterQuery}&source_slug=${catid}&alert=${alert}`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};

export const add_job = async (data) => {
  const requestObj = {
    path: `api/jobs`,
    method: "POST",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    postData: data,
  };
  return invokeApi(requestObj);
};
export const update_job = async (job_slug, data) => {
  const requestObj = {
    path: `api/jobs/update/${job_slug}`,
    method: "PUT",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    postData: data,
  };
  return invokeApi(requestObj);
};

export const live_job_feed_detail = async (id) => {
  const requestObj = {
    path: `api/jobs/detail/${id}`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };

  return invokeApi(requestObj);
};
export const get_job_type_list = async () => {
  const requestObj = {
    path: `api/job_type/active_job_type`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};
export const get_education_list = async () => {
  const requestObj = {
    path: `api/education/active_education`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};
export const get_experience_list = async () => {
  const requestObj = {
    path: `api/experience/active_experience`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};

export const get_favourites_job_api = async (catid, search, path) => {
  const requestObj = {
    path: `${path}&source_slug=${catid}&search=${search}`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};

export const applied_hob_list_for_candidate_client = async (
  Search,
  source_slug = "",
  page,
  limit
) => {
  const requestObj = {
    path: `api/jobs/applied_job_list?search=${Search}&source_slug=${source_slug}&page=${page}&limit=${limit}`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};

// job settings

export const get_client_email_setting = async () => {
  const requestObj = {
    path: `api/setting/get_client_email_setting`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};

export const update_client_email_setting = async (data) => {
  const requestObj = {
    path: `api/setting/update_client_email_setting`,
    method: "PUT",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    postData: data,
  };
  return invokeApi(requestObj);
};

export const email_template_list = async () => {
  const requestObj = {
    path: `api/email_template/list_email_template_for_client`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};

export const update_email_template = async (id, data) => {
  const requestObj = {
    path: `api/email_template/update_client_email_template/${id}`,
    method: "PUT",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    postData: data,
  };
  return invokeApi(requestObj);
};

export const yourecruite_api = async (completeURL, data) => {
  console.info("<==== Request Obj ====>", [...data]);
  const requestObj = {
    path: `${completeURL}`,
    method: "POST",
    postData: data,
    isCompletePath: true,
  };
  return invokeApi(requestObj);
};

// job alerts

export const get_job_alerts = async () => {
  const requestObj = {
    path: `api/alert/get_alert`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};

export const add_job_alert = async (data) => {
  const requestObj = {
    path: `api/alert/add_alert`,
    method: "POST",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    postData: data,
  };
  return invokeApi(requestObj);
};

export const job_alert_details = async (id) => {
  const requestObj = {
    path: `api/alert/get_alert_details/${id}`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};

export const update_job_alert = async (id, data) => {
  const requestObj = {
    path: `api/alert/update_alert/${id}`,
    method: "PUT",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    postData: data,
  };
  return invokeApi(requestObj);
};

export const delete_job_alert = async (id) => {
  const requestObj = {
    path: `api/alert/delete_alert/${id}`,
    method: "DELETE",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};

export const change_subscription_of_job_alert = async (id, data) => {
  const requestObj = {
    path: `api/alert/update_job_alert/${id}`,
    method: "PUT",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    postData: data,
  };
  return invokeApi(requestObj);
};
